"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function compareArrays(array1, array2) {
    return !!array1 && !!array2 &&
        Array.isArray(array1) && Array.isArray(array2) &&
        (array1.length === array2.length) &&
        array1.every(function (elem, index) {
            return elem === array2[index];
        });
}
exports.compareArrays = compareArrays;
;
//# sourceMappingURL=array-extensions.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/utilities/array-extensions.js
// module id = 1156
// module chunks = 0